module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"playGameA":"Spill bildene","playGameB":"Spill historien"},"en":{"playGameA":"Play Images","playGameB":"Play Story"}}')
  delete Component.options._Ctor
}
